// extracted by mini-css-extract-plugin
export default {"team":"team__43ij","left":"left_mbByU","right":"right_A0KTe"};